<section>
    <header class="d-flex align-items-center header">
        <h2 class="pl-2" (click)="showMetricsTab()" [ngClass]="{'highlight-tab' : metricsTabSelected}">
            X310/X410 Health Monitoring</h2>
        <div class="ver-line ml-3"></div>
        <h2 class="pl-3" (click)="showDetailsTab()" [ngClass]="{'highlight-tab' : detailsTabSelected}">
            X310/X410 Details</h2>
            <div class="ver-line ml-3"></div>
        <h2 class="pl-3" (click)="showMDCTab()" [ngClass]="{'highlight-tab' : mdcTabSelected}">
                MDC Details
        </h2>
    </header>
    <article>
        <div [hidden]="mdcTabSelected">
        <div [hidden]="detailsTabSelected">
            <div class="text-light text-center" *ngIf="!monitoringLoading">{{monitoringDataMessage}}</div>
            <div class="row m-0 row-custom" *ngIf="metricsData && metricsData.length > 0">
                <div class="col-md-4 p-1 total-area">
                    <div class="chart-size p-2">
                        <h3 class="mb-4">X310</h3>
                        <canvas baseChart *ngIf="x310data" [data]="chartsData.data" [colors]="chartColors"
                            [options]="pieChartOptions" [labels]="chartsData.labels"
                            [chartType]="pieChartType"></canvas>
                        <div class="total-count total-count-na" *ngIf="!x310data">N/A</div>
                        <div class="text-light intimation ml-2" *ngIf="metricsData && metricsData.length > 0">*SSR:
                            Solar
                            Script Running</div>
                    </div>
                </div>
                <div class="col-md-4 p-1 total-area">
                    <div class="chart-size p-2">
                        <h3>X310 Total Count</h3>
                        <div class="total-count">{{x310dataTotal}}</div>
                    </div>
                </div>
                <div class="col-md-4 p-1 total-area">
                    <div class="chart-size p-2">
                        <h3>X310 SSR Enabled Devices</h3>
                        <div class="total-count">{{x310dataSolarCount}}</div>
                    </div>
                </div>
                <div class="col-md-4 p-1 total-area">
                    <div class="chart-size p-2">
                        <h3 class="mb-4">X410</h3>
                        <canvas *ngIf="x410data" baseChart [data]="x410ChartData.data" [colors]="chartColors"
                            [options]="pieChartOptions" [labels]="x410ChartData.labels"
                            [chartType]="pieChartType"></canvas>
                        <div class="total-count total-count-na" *ngIf="!x410data">N/A</div>
                        <div class="text-light intimation ml-2" *ngIf="metricsData && metricsData.length > 0">*SSR:
                            Solar
                            Script Running</div>
                    </div>
                </div>
                <div class="col-md-4 p-1 total-area">
                    <div class="chart-size p-2">
                        <h3>X410 Total Count</h3>
                        <div class="total-count">{{x410dataTotal}}</div>
                    </div>
                </div>
                <div class="col-md-4 p-1 total-area">
                    <div class="chart-size p-2">
                        <h3>X410 SSR Enabled Devices</h3>
                        <div class="total-count">{{x410dataSolarCount}}</div>
                    </div>
                </div>
            </div>
        </div>
     </div>
        <!-- <div class="text-light text-center" *ngIf="loading">Loading data, please wait....</div> -->
        <div [hidden]="!detailsTabSelected">
            <div>
                <div class="d-flex justify-content-end align-items-center mb-2 mt-2" *ngIf="!x310DetailsLoading">
                    <input type="text" id="x310-input" class="custom-input mr-2" [(ngModel)]="filterValue"
                        (keydown.enter)="filterData()" placeholder="Search...">
                    <div (click)="downloadExcel()" *ngIf="healthMonitoringFilteredData?.length > 0">
                        <i class="fa fa-download custom-download"></i>
                    </div>
                </div>
                <div class="text-light text-center" *ngIf="!x310DetailsLoading || healthMonitoringFilteredData?.length==0">
                    {{healthMonitoringFilteredDataMessage}}
                </div>
                <div class="table-data">
                    <table class="table table table-bordered"
                        *ngIf="healthMonitoringFilteredData && healthMonitoringFilteredData.length > 0">
                        <thead>
                            <tr>
                                <th scope="col">
                                    <div class="d-flex align-items-center justify-content-center"
                                        (click)="sortItems('potentialId')">
                                        <span>Potential Id</span>
                                        <span class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </span>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div class="d-flex align-items-center justify-content-center"
                                        (click)="sortItems('siteName')">
                                        <span>Site Name</span>
                                        <span class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </span>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div class="d-flex align-items-center justify-content-center"
                                        (click)="sortItems('type')">
                                        <span>Type</span>
                                        <span class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </span>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div class="d-flex align-items-center justify-content-center"
                                        (click)="sortItems('status')">
                                        <span>Status</span>
                                        <span class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </span>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div class="d-flex align-items-center justify-content-center"
                                        (click)="sortItems('solarState')">
                                        <span>Solar State</span>
                                        <span class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </span>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div class="d-flex align-items-center justify-content-center"
                                        (click)="sortItems('lineVoltage')">
                                        <span>Line Voltage State</span>
                                        <span class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </span>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div class="d-flex align-items-center justify-content-center"
                                        (click)="sortItems('batteryVoltage')">
                                        <span>Battery Voltage</span>
                                        <span class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </span>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div class="d-flex align-items-center justify-content-center"
                                        (click)="sortItems('encoder')">
                                        <span>Encoder</span>
                                        <span class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </span>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div class="d-flex align-items-center justify-content-center"
                                        (click)="sortItems('realy2')">
                                        <span>Relay2</span>
                                        <span class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </span>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div class="d-flex align-items-center justify-content-center"
                                        (click)="sortItems('siren')">
                                        <span>Siren</span>
                                        <span class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </span>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div class="d-flex align-items-center justify-content-center"
                                        (click)="sortItems('router')">
                                        <span>Router</span>
                                        <span class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </span>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div class="d-flex align-items-center justify-content-center"
                                        (click)="sortItems('temperature')">
                                        <span>Temperature(F)</span>
                                        <span class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </span>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div class="d-flex align-items-center justify-content-center"
                                        (click)="sortItems('reason')">
                                        <span>Reason</span>
                                        <span class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </span>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div class="d-flex align-items-center justify-content-center"
                                        (click)="sortItems('devDate')">
                                        <span>Device Time</span>
                                        <span class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="let data of healthMonitoringFilteredData | paginate: { itemsPerPage: perPageItems, currentPage: p, id:'1' }; let i=index;">
                                <td>{{data.potentialId ? data.potentialId : 'N/A'}}</td>
                                <td>{{data.siteName ? data.siteName : 'N?A'}}</td>
                                <td (click)="showdeviceData(data)" class="c_point">{{data.type ? data.type : 'N/A'}}</td>
                                <td>
                                    <span *ngIf="data.status.toLowerCase() == 'up'" class="up-status"></span>
                                    <span *ngIf="data.status.toLowerCase() == 'down'" class="down-status"></span>
                                    <span *ngIf="data?.status == 'Not Monitoring'" class="monitor-status"></span>
                                </td>
                                <td>{{(data.solarState == true || data.solarState == false) ? data.solarState : 'N/A'}}
                                </td>
                                <td>{{(data.lineVoltage == 1) ? 'ON' : (data.lineVoltage == 0) ? 'OFF' : 'N/A'}}</td>
                                <td>{{data.batteryVoltage ? data.batteryVoltage : 'N/A'}}</td>
                                <td>{{(data.encoder == 1) ? 'ON' : (data.encoder == 0) ? 'OFF' : 'N/A'}}</td>
                                <td>{{(data.realy2 == 1) ? 'ON' : (data.realy2 == 0) ? 'OFF' : 'N/A'}}</td>
                                <td>{{(data.siren == 1) ? 'ON' : (data.siren == 0) ? 'OFF' : 'N/A'}}</td>
                                <td>{{(data.router == 1) ? 'ON' : (data.router == 0) ? 'OFF' : 'N/A'}}</td>
                                <td>{{data.temperature ? data.temperature : 'N/A'}}</td>
                                <td>{{data.reason ? data.reason : 'N/A'}}</td>
                                <td>{{data.devDate ? data.devDate : 'N/A'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="footer-section" *ngIf="!x310DetailsLoading && healthMonitoringFilteredData?.length>0">
                    <span class="mr-3"><b>Items per page:</b>{{perPageItems}}</span>
                    <span><b>{{(healthMonitoringFilteredData && (healthMonitoringFilteredData.length < perPageItems)) ?
                                healthMonitoringFilteredData.length : ((p * perPageItems) > healthMonitoringFilteredData.length ? healthMonitoringFilteredData.length : (p * perPageItems))}}</b> of
                                <b>{{healthMonitoringFilteredData ? healthMonitoringFilteredData.length : '0'}}</b></span>
                    <pagination-controls id="1" (pageChange)="p = $event"></pagination-controls>
                </div>
            </div>
        </div>
        <!-- <div class="text-light text-center" *ngIf="healthMonitoringFilteredData?.length==0">{{healthMonitoringFilteredDataMessage}}</div> -->
        <div [hidden]="!mdcTabSelected">
           <div>
            <div class="d-flex justify-content-end align-items-center mb-2 mt-2" *ngIf="!mdcLoading">
                <input type="text" id="mdc-input" class="custom-input mr-2" [(ngModel)]="filterMDCValue"
                    (keydown.enter)="filterMDCData()" placeholder="Search...">
                <div (click)="downloadMdcExcel()" *ngIf="mdcData.length>0"><i class="fa fa-download custom-download"></i></div>
            </div>
            <div class="text-light text-center" *ngIf="!mdcLoading || mdcData.length==0">{{mdcDataMessage}}</div>
            <div class="table-data">
                <table class="table table table-bordered"
                    *ngIf="mdcData && mdcData.length > 0">
                    <thead>
                        <tr>
                            <th scope="col">
                                <div class="d-flex align-items-center justify-content-center"
                                    (click)="sortMDCItems('potentialId')">
                                    <span>Potential ID</span>
                                    <span class="pl-2">
                                        <div class="arrow-section"><i class="arrow up"></i></div>
                                        <div class="arrow-section"><i class="arrow down"></i></div>
                                    </span>
                                </div>
                            </th>
                            <th scope="col">
                                <div class="d-flex align-items-center justify-content-center"
                                    (click)="sortMDCItems('siteName')">
                                    <span>Site Name</span>
                                    <span class="pl-2">
                                        <div class="arrow-section"><i class="arrow up"></i></div>
                                        <div class="arrow-section"><i class="arrow down"></i></div>
                                    </span>
                                </div>
                            </th>
                            <th scope="col">
                                <div class="d-flex align-items-center justify-content-center"
                                    (click)="sortMDCItems('deviceName')">
                                    <span>Device Name</span>
                                    <span class="pl-2">
                                        <div class="arrow-section"><i class="arrow up"></i></div>
                                        <div class="arrow-section"><i class="arrow down"></i></div>
                                    </span>
                                </div>
                            </th>
                            <th scope="col">
                                <div class="d-flex align-items-center justify-content-center"
                                    (click)="sortMDCItems('siteType')">
                                    <span>Site Type</span>
                                    <span class="pl-2">
                                        <div class="arrow-section"><i class="arrow up"></i></div>
                                        <div class="arrow-section"><i class="arrow down"></i></div>
                                    </span>
                                </div>
                            </th>
                            <th scope="col">
                                <div class="d-flex align-items-center justify-content-center"
                                    (click)="sortMDCItems('status')">
                                    <span>Status</span>
                                    <span class="pl-2">
                                        <div class="arrow-section"><i class="arrow up"></i></div>
                                        <div class="arrow-section"><i class="arrow down"></i></div>
                                    </span>
                                </div>
                            </th>
                            <th scope="col">
                                <div class="d-flex align-items-center justify-content-center"
                                    (click)="sortMDCItems('siteUnitId')">
                                    <span>Site UnitId</span>
                                    <span class="pl-2">
                                        <div class="arrow-section"><i class="arrow up"></i></div>
                                        <div class="arrow-section"><i class="arrow down"></i></div>
                                    </span>
                                </div>
                            </th>
                            <th scope="col">
                                <div class="d-flex align-items-center justify-content-center"
                                    (click)="sortMDCItems('solarEnabled')">
                                    <span>Solar Enabled</span>
                                    <span class="pl-2">
                                        <div class="arrow-section"><i class="arrow up"></i></div>
                                        <div class="arrow-section"><i class="arrow down"></i></div>
                                    </span>
                                </div>
                            </th>
                            <th scope="col">
                                <div class="d-flex align-items-center justify-content-center"
                                    (click)="sortMDCItems('deviceId')">
                                    <span>Device Id</span>
                                    <span class="pl-2">
                                        <div class="arrow-section"><i class="arrow up"></i></div>
                                        <div class="arrow-section"><i class="arrow down"></i></div>
                                    </span>
                                </div>
                            </th>
                            <th scope="col">
                                <div class="d-flex align-items-center justify-content-center"
                                    (click)="sortMDCItems('deviceUqId')">
                                    <span>Device Unique Id</span>
                                    <span class="pl-2">
                                        <div class="arrow-section"><i class="arrow up"></i></div>
                                        <div class="arrow-section"><i class="arrow down"></i></div>
                                    </span>
                                </div>
                            </th>
                            <th scope="col">
                                <div class="d-flex align-items-center justify-content-center"
                                    (click)="sortMDCItems('deviceType')">
                                    <span>Device Type</span>
                                    <span class="pl-2">
                                        <div class="arrow-section"><i class="arrow up"></i></div>
                                        <div class="arrow-section"><i class="arrow down"></i></div>
                                    </span>
                                </div>
                            </th>
                            <th scope="col">
                                <div class="d-flex align-items-center justify-content-center"
                                    (click)="sortMDCItems('accId')">
                                    <span>Account Id</span>
                                    <span class="pl-2">
                                        <div class="arrow-section"><i class="arrow up"></i></div>
                                        <div class="arrow-section"><i class="arrow down"></i></div>
                                    </span>
                                </div>
                            </th>
                            <th scope="col">
                                <div class="d-flex align-items-center justify-content-center"
                                    (click)="sortMDCItems('duration')">
                                    <span>Duration</span>
                                    <span class="pl-2">
                                        <div class="arrow-section"><i class="arrow up"></i></div>
                                        <div class="arrow-section"><i class="arrow down"></i></div>
                                    </span>
                                </div>
                            </th>
                            <th scope="col">
                                <div class="d-flex align-items-center justify-content-center"
                                    (click)="sortMDCItems('promStatus')">
                                    <span>Prom Status</span>
                                    <span class="pl-2">
                                        <div class="arrow-section"><i class="arrow up"></i></div>
                                        <div class="arrow-section"><i class="arrow down"></i></div>
                                    </span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            *ngFor="let data of mdcData | paginate: { itemsPerPage: perPageItems, currentPage: p1, id:'2'}; let i=index;">
                            <td>{{data.potentialId ? data.potentialId : 'N/A'}}</td>
                            <td>{{data.siteName ? data.siteName : 'N/A'}}</td>
                            <td (click)="showMDCData(data)" class="c_point">{{data.deviceName ? data.deviceName : 'N/A'}}</td>
                            <td>{{data.siteType ? data.siteType : 'N/A'}}</td>
                            <td>
                                <span *ngIf="data?.status?.toLowerCase() == 'up'" class="up-status"></span>
                                <span *ngIf="data?.status?.toLowerCase() == 'down'" class="down-status"></span>
                                <span *ngIf="data?.status == 'Not Monitoring'" class="monitor-status"></span>
                            </td>
                            <td>{{data.siteUnitId ? data.siteUnitId : 'N/A'}}</td>
                            <td *ngIf="(data.solarEnabled == true)">true</td>
                            <td *ngIf="(data.solarEnabled == false)">false</td>
                            <td>{{data.deviceId ? data.deviceId : 'N/A'}}</td>
                            <td>{{data.deviceUqId ? data.deviceUqId : 'N/A'}}</td>
                            <td>{{data.deviceType ? data.deviceType : 'N/A'}}</td>
                            <td>{{data.accId ? data.accId : 'N/A'}}</td>
                            <td>{{data.duration ? data.duration : 'N/A'}}</td>
                            <td>{{data.promStatus ? data.promStatus : 'N/A'}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="footer-section" *ngIf="!mdcLoading && mdcData.length > 0">
                <span class="mr-3"><b>Items per page:</b>{{perPageItems}}</span>
                <span><b>{{(mdcData && (mdcData.length < perPageItems)) ?
                    mdcData.length : ((p1 * perPageItems) > mdcData.length ? mdcData.length : (p1 * perPageItems))}}</b> of
                            <b>{{mdcData ? mdcData.length : '0'}}</b></span>
                <pagination-controls id="2" (pageChange)="p1 = $event"></pagination-controls>
            </div>    
           </div>
        </div>
        <div class="text-light text-center" *ngIf="!loading && mdcData?.length==0">{{mdcDataMessage}}</div>
    </article>
</section>

<div class="mainbox" id="myModal1" style="z-index: 99999;" [ngStyle]="{'display':displayStyle1}">
    <div class="model_sub_box">
        <div (click)="closePopup()" class="close_button_box">
            <button type="button" class="close">&times;</button>
        </div>
        <app-solar-script-dialog [deviceInfoData]="deviceInfoDataObj"></app-solar-script-dialog>
    </div>
</div>

<div class="mainbox2" id="myModal4" [ngStyle]="{'display':displayStyle2}">
    <div class="model_sub_box2" style="margin-top: 5px;">
        <div (click)="closeMdcdata()" class="close_button_box">
            <button type="button" class="close">&times;</button>
        </div>
        <app-mdc-data [mdcData]="mdcMetadata"></app-mdc-data>
    </div>
</div>